import React, { Fragment, useState, useEffect, useContext } from "react";
import { useConfirm } from "../../common/use-confirm";
import { useAlert, useSelected } from "../organize/OrganizeProvider";

import ConfirmDialog from "../../components/ConfirmDialog";
import { notBlank } from "../../util/ext";
import { GroupBrowserContext } from "../organize/OrganizeView";

// TODO: add generalized version of this component for manager panel
const DeleteDialog = ({
  type = "content group",
  count,
  handleDelete,
  renderButton,
}) => {
  const confirmHandler = useConfirm();
  const { showConfirm } = confirmHandler;
  const { removeAllSelected } = useSelected();
  const alert = useAlert();
  const browser = useContext(GroupBrowserContext);

  const [title, setTitle] = useState("Delete this content group?");
  const [body, setBody] = useState(
    "Any media added to this content group will not be deleted.",
  );

  useEffect(() => {
    if (notBlank(count) && count > 1) {
      setTitle("Delete these content groups?");
      setBody("Any media added to these content groups will not be deleted.");
    }
  }, [count]);

  const onDelete = callback => {
    showConfirm(
      title,
      body,
      {
        onConfirm: async () => {
          browser.setLoading(true);
          try {
            await handleDelete();
            removeAllSelected();
            alert.show("info", ["Item Deleted"], true);
            if (typeof callback === "function") {
              callback();
            }
          } catch (err) {
            alert.show("error", [err.message]);
          }
          browser.setLoading(false);
        },
        onCancel: () => {
          removeAllSelected();
          if (typeof callback === "function") {
            callback();
          }
        },
      },
      "Delete",
    );
  };

  return (
    <Fragment>
      <ConfirmDialog handler={confirmHandler} />

      {renderButton(onDelete)}
    </Fragment>
  );
};

export default DeleteDialog;
